


//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/mock/empty.js
// module id = 676
// module chunks = 0